<template>
	<div id="app">
		<Header />
		<router-view />
		<Footer v-show="!$route.meta.hiddenFooter" />
	</div>
</template>
<script>
import Footer from "./components/Footer";
import Header from "./components/Header";
import seoDictionary from "./utils/seoDictionary";
export default {
	components: {
		Footer,
		Header,
	},
	data() {
		return {
			news: [],
			footerShow: true,
		};
	},
	metaInfo() {
		let routeName = this.$route.name;
		let currentSeoInfo = seoDictionary.getDictionaryDataByRouteName(routeName);
		if (currentSeoInfo) {
			return {
				title: currentSeoInfo.title,
			};
		}
	},
	created() {},
	mounted() {
		if (this.$route.name == "news") {
			this.footerShow = false;
		} else {
			this.footerShow = true;
		}
		setTimeout(function (e) {
			// 百度
		var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?f9a07c61281a73ac2f18070a617a34b9";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
      })();
		}, 1000);

		//跳转pc端
		let hostname = window.location.href;
		if (!this._isMobile()) {
			if (hostname) {
				if (hostname.indexOf("localhost") > 0) {
					window.location.href = "//www.qftx.com/"; //线上环境
				} else if (hostname.indexOf("www.qftx.com/m_index.html") > 0) {
					window.location.href = "//www.qftx.com/"; //线上环境
				}
			}
		}
	},
	methods: {
		_isMobile() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			);
			return flag;
		},
	},
};
</script>

<style lang="scss">
#app {
	margin-top: 90px;
}
</style>
